import { useState } from 'react';
import { Button, SearchInput, Alert } from '../../components/ui';
import { buscarMedicosPorNombre } from '../../api/medicos';
import ListaMedicos from './ListaMedicos';
import './Buscar.css';

export default function PasoNombre({ onElegir, onVolver }) {
  const [termino, setTermino] = useState('');
  const [medicos, setMedicos] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');

  const buscar = async (e) => {
    e.preventDefault();
    if (!termino.trim()) return;
    setCargando(true); setError(''); setMedicos(null);
    try {
      const data = await buscarMedicosPorNombre(termino.trim());
      setMedicos(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setCargando(false);
    }
  };

  return (
    <section aria-labelledby="t1">
      <h2 id="t1">Búsqueda por nombre</h2>
      <p className="buscar-muted">
        Escribí el nombre del profesional. Se muestran los médicos cuyo nombre contenga el término buscado.
      </p>

      <form role="search" onSubmit={buscar} style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
        <label className="sr-only" htmlFor="qmed">Nombre del médico</label>
        <SearchInput id="qmed" value={termino} onChange={(e) => setTermino(e.target.value)} placeholder="Ej. González" />
        <Button type="submit" disabled={!termino.trim()}>Buscar</Button>
      </form>

      {error && <Alert tone="danger" title="No pudimos buscar">{error}</Alert>}

      <ListaMedicos cargando={cargando} medicos={medicos} termino={termino} onElegir={onElegir} />

      <div className="buscar-actions">
        <Button variant="secondary" onClick={onVolver}>← Volver</Button>
      </div>
    </section>
  );
}